import React from 'react';

const ResultadoDetailTablaPuestos = (props) => {
  const resultado = props.resultado;

  if (props.controlList) {
    return (
      <div className="w-full pb-6">
        <div className="mx-auto max-w-5xl px-4 md:px-40">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-slate-700">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Control
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Puesto
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Género
                  </th>
                  <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                    Categoría
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.controlList.map((control) => {
                  const puesto = resultado['control_' + control.id + '_puesto'];
                  const puestoSexo = resultado['control_' + control.id + '_puesto_' + resultado['sexo']];
                  const puestoCategoria = resultado['control_' + control.id + '_puesto_categoria'];

                  return (
                    <tr key={control.id} className="border-b border-slate-800 hover:bg-slate-900/30 transition">
                      <td className="py-3 px-4">
                        <div className="text-white font-medium font-montserrat text-sm">
                          {control.nombre}
                        </div>
                        {control.descripcion && (
                          <div className="text-xs text-slate-500 font-montserrat mt-1">
                            {control.descripcion}
                          </div>
                        )}
                      </td>
                      <td className="text-right py-3 px-4 text-white font-semibold font-montserrat text-sm">
                        {puesto || <span className="text-slate-500">---</span>}
                      </td>
                      <td className="text-right py-3 px-4 text-slate-300 font-montserrat text-sm">
                        {puestoSexo || <span className="text-slate-500">---</span>}
                      </td>
                      <td className="text-right py-3 px-4 text-slate-300 font-montserrat text-sm">
                        {puestoCategoria || <span className="text-slate-500">---</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
};

export default ResultadoDetailTablaPuestos;